import { uri } from '../../api-endpoint';
import {
  IAnnotationAPIValidationError,
  IAnnotationFromAPISuccessResponse
} from '../../type-conversion/annotation/from-api-repsonse';
import { AnnotationAPIRequestBodyPartial } from '../../type-conversion/annotation/to-api-request-body';
import { updatePartiallyTemplateFn } from '../common';

export const updateModelImageAnnotationPartially = (token: string) => (
  modelId: number,
  imageId: number,
  annotationUuid: string
) =>
  updatePartiallyTemplateFn(
    token,
    uri.modelImageAnnotationById(modelId, imageId, annotationUuid),
    AnnotationAPIRequestBodyPartial,
    IAnnotationFromAPISuccessResponse,
    IAnnotationAPIValidationError
  );
